import { useMedia } from 'react-use';

import { desktopAndAbove } from '#src/style/mediaQuery.ts';

export const useIsDesktopAndAbove = () => useMedia(desktopAndAbove);
